// extracted by mini-css-extract-plugin
export default {"Body":"media_Body__XYgjL","Content":"media_Content__1ll77","Media":"media_Media__gcthV","Medium":"media_Medium__ACdfK","MediaHeader":"media_MediaHeader__nM2tk"};